import { ActionTypeList } from '../constants'

const initialState = {
    loading: false,
    publicPlans: [],
    hasCalledApi: false,
    error: ""
};

export const publicPlansPayload = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypeList.PUBLIC_PLANS_FETCHED:
            console.log(`${new Date()}: action.payload ${JSON.stringify(action.payload)}`);

            return {
                loading: false,
                publicPlans: action.payload ?? [],
                hasCalledApi: true,
                error: ""
            };
        case ActionTypeList.PUBLIC_PLANS_FETCH:
            return {
                loading: true,
                publicPlans: [],
                hasCalledApi: true,
                error: action.payload
            };
        default:
            return state;
    }
}

const initialCancellationState = {
    loading: false,
    success: null,
    showScreen: false,
    error: ""
};

export const accountSubscriptionCancellationStatusPayload = (state = initialCancellationState, action) => {
    switch (action.type) {
        case ActionTypeList.ACCOUNT_SUBSCRIPTION_CANCELLED:
            return {
                ...state,
                loading: false,
                success: true,
                data: "Your subscription cancellation has been submitted.",
                error: ""
            };
        case ActionTypeList.ACCOUNT_SUBSCRIPTION_CANCEL:
            return {
                ...state,
                loading: true,
                success: false,
                error: action.payload.data.error
            };
        case ActionTypeList.CLOSE_MESSAGE_BOX:
        case ActionTypeList.ACCOUNT_SUBSCRIPTION_CANCELLATION_CLOSE_SCREEN:
            
            return { ...initialCancellationState };
        case ActionTypeList.ACCOUNT_SUBSCRIPTION_CANCELLATION_SHOW_SCREEN:
            return {
                ...state,
                showScreen: true
            };
        default:
            return state;
    }
}
